import { z } from 'zod';
import {
  DESCRIPTION_MAX_LENGTH,
  MEASURE_NAME_MAX_LENGTH,
} from '../../../../../config/constants';
import { measureDisplayFormatSchema } from '../../../../../utils/builder/measures/measureDisplayFormat/validationSchemas';

export const saveMeasureSchema = z
  .object({
    strategy: z.enum(['create', 'update']),
    name: z.string().trim().max(MEASURE_NAME_MAX_LENGTH),
    description: z.string().trim().max(DESCRIPTION_MAX_LENGTH).nullable(),
    comment: z.string().nullable(),
    versionId: z.string().nullable(),
    format: measureDisplayFormatSchema.nullable(),
  })
  .superRefine((values, ctx) => {
    const { strategy, name, versionId } = values;

    if (strategy === 'create' && !name) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Field is required',
        path: ['name'],
        fatal: true,
      });

      return z.NEVER;
    }

    if (strategy === 'update' && !versionId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Field is required',
        path: ['versionId'],
        fatal: true,
      });

      return z.NEVER;
    }
  });
